const keys: Array<string> = [
  'loy.bp.shop.title',
  'loy.bp.shop.subtitle',
  'loy.bp.shop.public.subtitle',
  'bp.points',
  'product.article.badge.new',
  'mzp.bonuspoints.savemore',
  'loy.rewards.shop.loadmore',
  'loy.rewards.shop.filter.type.product',
  'loy.rewards.shop.filter.price',
  'mzp.bp.product.filter.previousrewards',
  'loy.rewards.shop.filter.more',
  'loy.rewards.shop.filter.title',
  'loy.rewards.shop.filter.type.pet',
  'loy.rewards.shop.filter.type.product',
  'loy.rewards.shop.filter.clearall',
  'loy.rewards.shop.filter.shownumberofrewards',
  'loy.rewards.shop.filter.showrewards',
  'loy.rewards.shop.filter.clear',
  'loy.rewards.shop.filter.save',
  'loy.rewards.shop.filter.shop',
  'mzp.bp.product.filter.noresult',
  'loy.rewards.shop.filter.products',
  'loy.rewards.shop.filter.closeButton',
  'loy.rewards.shop.filter.selectedPetTypes',
  'loy.rewards.shop.filter.selectedProductTypes',
  'loy.rewards.shop.filter.sliderRangeHigh',
  'loy.rewards.shop.filter.sliderRangeLow',
  'loy.rewards.shop.filter.numberOfItems',
  'loy.rewards.shop.filter.goBackButton',
  'loy.rewards.shop.filter.clearFiltersButton',
  'mzp.points.points',
  'loy.rewards.shop.filter.unlimited',
  'loy.rewards.shop.donate.subtitle',
  'loy.rewards.shop.donate.title',
  'loy.rewards.shop.donate.info',
  'loy.points.expiry',
  'loy.bp.what-are-zoopoints',
  'loy.rewardshop.link',
  'loy.points.available',
  'mzp.overview.bonus-program.view-reward-shop',
  'loy.rewards.shop.promotions.title',
  'loy.rewards.shop.promotions.subtitle',
  'loy.bp.gift.announcement',
  'loy.bp.gift.announcement.subtitle',
  'loy.rewards.shop.filter.donate',
  'loy.rewards.shop.filter.redeemablerewards',
  'loy.bp.shutdown.breadcrumb',
  'loy.bp.shutdown.redeem',
  'loy.bp.shutdown.title',
  'loy.bp.shutdown.paragraph-1',
  'loy.bp.shutdown.paragraph-2',
  'loy.bp.shutdown.paragraph-3',
  'loy.bp.shutdown.bp.title',
  'loy.bp.shutdown.progressbar.title',
  'loy.bp.shutdown.progressbar.now',
  'loy.bp.shutdown.progressbar.now.description',
  'loy.bp.shutdown.progressbar.start.date',
  'loy.bp.shutdown.progressbar.start.date.description',
  'loy.bp.shutdown.progressbar.end.date',
  'loy.bp.shutdown.progressbar.end.date.description',
  'loy.bp.shutdown.progressbar.paragraph-1',
  'loy.bp.shutdown.progressbar.paragraph-2',
  'loy.bp.shutdown.faqs',
  'loy.bp.shutdown.faq-1',
  'loy.bp.shutdown.faq-1.content',
  'loy.bp.shutdown.faq-2',
  'loy.bp.shutdown.faq-2.content',
  'loy.bp.shutdown.faq-3',
  'loy.bp.shutdown.faq-3.content',
  'loy.bp.shutdown.faq-4',
  'loy.bp.shutdown.faq-4.content',
  'loy.bp.shutdown.faq-5',
  'loy.bp.shutdown.faq-5.content',
  'loy.bp.shutdown.read.more',
  'loy.bp.shutdown.progressbar.progress',
  'loy.bp.shutdown.programs.title',
  'loy.bp.shutdown.programs.autoshipment.title',
  'loy.bp.shutdown.programs.autoshipment.description',
  'loy.bp.shutdown.programs.autoshipment.link',
  'loy.bp.shutdown.programs.sp.title',
  'loy.bp.shutdown.programs.sp.description',
  'loy.bp.shutdown.programs.sp.link',
  'loy.bp.shutdown.programs.raf.title',
  'loy.bp.shutdown.programs.raf.description',
  'loy.bp.shutdown.programs.raf.link',
];

export default keys;
